import React from "react";
import VideoThumbnailCard from "./VideoThumbnailCard";
import { Form } from "react-bootstrap";
import "./VideoList.css";
import { connect } from "react-redux";
import {
  fetchVideos,
  videoWatched,
  fetchAutoplayVideo,
} from "../../actions/videoActions";
import InfoModal from "../modals/InfoModal";
import history from "../../config/history";
import SkeletonCardsList from "../skeleton-card/SkeletonCardsList";
import VimeoPlayer from "@vimeo/player";
import { convertVimeoUrl } from "../../utils";
import { InView } from "react-intersection-observer";
// import { browserHistory } from 'react-router';
class VideoList extends React.Component {
  playerRef = React.createRef();

  async componentDidMount() {
    window.history.pushState(null, null, window.location.pathname);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.handleCloseVideoModal);
    this.player && this.player.off("ended");
    this.player && this.player.off("timeupdate", this.handleVideoWatched);
  }
  state = {
    showVideoModal: false,
    imgsLoaded: 0,
    videoLinkToPlay: null,
    videoIdToPlay: null,
    sendWatchedRequest: true,
    videoLoaded: false,
    searchTerm: "",
    subscribeModalShow: false,
    videoPlayOrder: 0,
  };

  videoPlayerRef = React.createRef();

  scrollToVideoPlayer = () =>
    window.scrollTo({
      left: 0,
      top:
        this.playerRef.current.offsetTop -
        (window.innerHeight - this.playerRef.current.clientHeight) / 2,
      behavior: "smooth",
    });

  imgOnLoad = () => {
    this.setState({ imgsLoaded: this.state.imgsLoaded + 1 });
  };

  playVideo = async (firstVideo = false) => {
    if (!this.player || !this.state.videoLinkToPlay) {
      history.go(0);
    }

    await this.player
      .loadVideo({ url: convertVimeoUrl(this.state.videoLinkToPlay) })
      .catch((err) => console.log(err));

    this.scrollToVideoPlayer();

    firstVideo &&
      (await this.player.requestFullscreen().catch((err) => console.log(err)));

    await this.player.play().catch((err) => console.log(err));

    this.setState({ videoLinkToPlay: undefined, sendWatchedRequest: true });
  };

  handleVideoEnd = async () => {
    const { videoLink, nextVideoPlayOrder, videoId } =
      await this.props.fetchAutoplayVideo(this.state.videoPlayOrder);

    this.setState({
      videoLinkToPlay: videoLink,
      videoPlayOrder: nextVideoPlayOrder,
      videoIdToPlay: videoId,
    });

    this.playVideo();
  };

  handleVideoThumbnailClick = (videoLink, playOrder, videoId) => {
    if (!this.player) {
      this.player = new VimeoPlayer(this.playerRef.current, {
        url: convertVimeoUrl(videoLink),
        responsive: true
      });
      this.player.on("ended", this.handleVideoEnd);
      this.player.on("timeupdate", this.handleVideoWatched);
    }

    this.setState({
      videoLinkToPlay: videoLink,
      videoPlayOrder: playOrder,
      videoIdToPlay: videoId,
    });

    this.playVideo(true);
  };

  handleShowSubscribeModal = () => {
    this.setState({
      subscribeModalShow: true,
    });
  };

  handleCloseSubscribeModal = () => {
    this.setState({
      subscribeModalShow: false,
    });
  };

  handleShowVideoModal = (videoId, playOrder) => {
    this.setState({
      showVideoModal: true,
      videoLinkToPlay: this.props.videoLink,
      videoIdToPlay: videoId,
      sendWatchedRequest: true,
      videoPlayOrder: playOrder,
    });

    window.addEventListener("popstate", this.handleCloseVideoModal);

    this.scrollToVideoPlayer();
  };

  handleCloseVideoModal = () => {
    this.setState({
      showVideoModal: false,
      sendWatchedRequest: false,
      videoLoaded: false,
    });
    window.removeEventListener("popstate", this.handleCloseVideoModal);
  };

  handleVideoWatched = async (progress) => {
    if (this.state.sendWatchedRequest && progress.percent >= 0.75) {
      this.setState({ sendWatchedRequest: false });
      await this.props.videoWatched(this.state.videoIdToPlay);
    }
  };

  handleVideoOnEnd = async () => {
    const { nextVideoId, nextVideoPlayOrder } =
      await this.props.fetchAutoplayVideo(this.state.videoPlayOrder);
    this.handleShowVideoModal(nextVideoId, nextVideoPlayOrder);
  };

  renderList() {
    return (
      <div className="video-list-container">
        <InfoModal
          modalShow={this.state.subscribeModalShow}
          onHide={this.handleCloseSubscribeModal}
          closeButton={true}
          actionButton={() => history.push("/pricing")}
          heading={"Subscribe!"}
          bodyContent={"Subscribe to MenduToons to access premium content"}
          actionButtonText={"Subscribe"}
        />

        {/* Video Cards */}
        <div
          className="row video-list-inner-container"
          style={
            this.state.imgsLoaded >= this.props.videosCount
              ? {}
              : { display: "none" }
          }
        >
          <VideoThumbnailCard
                video={{
                  isFreeVideo: true,
                  playOrder: 1,
                  _id: process.env.REACT_APP_MAGIC_SONG_VIDEO_ID,
                  title: "Magic of MeenduToons Song",
                  thumbnailLink:
                    `${process.env.REACT_APP_AWS_IMG_CDN}/thumbnails/videos-stories/Magic+of+MeenduToons+Song.png`,
                  category: "Song",
                }}
                handleVideoThumbnailClick={this.handleVideoThumbnailClick}
                imgOnLoad={this.imgOnLoad}
                handleShowSubscribeModal={this.handleShowSubscribeModal}
                handleCloseSubscribeModal={this.handleCloseSubscribeModal}
                isSpecial
              />
         <VideoThumbnailCard
                video={{
                  isFreeVideo: true,
                  playOrder: 1,
                  _id: process.env.REACT_APP_THEME_SONG_VIDEO_ID,
                  title: "Values Theme Song",
                  thumbnailLink:
                    `${process.env.REACT_APP_AWS_IMG_CDN}/thumbnails/videos-stories/Values+Song.png`,
                  category: "Song",
                }}
                handleVideoThumbnailClick={this.handleVideoThumbnailClick}
                imgOnLoad={this.imgOnLoad}
                handleShowSubscribeModal={this.handleShowSubscribeModal}
                handleCloseSubscribeModal={this.handleCloseSubscribeModal}
                isSpecial
              />
          {this.props.videos &&
            this.props.videos?.length > 0 &&
            this.props.videos
              .filter((val) => {
                if (!this.props.searchEnabled || this.state.searchTerm === "") {
                  return val;
                } else if (
                  val.title
                    .toLowerCase()
                    .includes(this.state.searchTerm.toLowerCase())
                ) {
                  return val;
                } else {
                  return null;
                }
              })
              .map((video, key) => (
                <VideoThumbnailCard
                  key={key}
                  video={video}
                  handleVideoThumbnailClick={this.handleVideoThumbnailClick}
                  imgOnLoad={this.imgOnLoad}
                  handleShowSubscribeModal={this.handleShowSubscribeModal}
                  handleCloseSubscribeModal={this.handleCloseSubscribeModal}
                />
              ))}
        </div>

        {/* Skeleton cards */}
        <div
          className="row video-list-inner-container"
          style={
            !this.state.imgsLoaded ||
            this.state.imgsLoaded >= this.props.videosCount
              ? { display: "none" }
              : {}
          }
        >
          <SkeletonCardsList
            count={this.props.videosCount ? this.props.videosCount : 5}
            width="14rem"
            height="9.5rem"
            borderRadius="5%"
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div>
          <div className="container videos-list-content-heading-container">
            <h2 className="hp-section-heading">
              Videos
            </h2>
            {this.props.searchEnabled && (
              <Form.Control
                className="videos-content-search-bar"
                size="md"
                type="text"
                placeholder="Search videos…"
                onChange={(e) => this.setState({ searchTerm: e.target.value })}
              />
            )}
          </div>

          <div style={{display: "flex", justifyContent:"center", alignItems: "center"}}>
            <div ref={this.playerRef} className="vimeo-player"></div>
          </div>
        </div>

        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <div ref={ref} className={`hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
              {this.renderList()}
            </div>
          )}
        </InView>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // videos: state.videos.videos?.videos,
    loading: state.videos.loading,
    // videosCount: state.videos.videos.videosCount,
    videoLink: state.videos?.videoLink,
    nextVideoId: state.videos?.nextVideoId,
    nextVideoPlayOrder: state.videos?.nextPlayOrder,
    // userData: state.checkUser.userData,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchVideos,
  videoWatched,
  fetchAutoplayVideo,
})(VideoList);
